import React from "react";
import Helmet from "react-helmet";
const { REACT_APP_COLBI_THEME } = process.env;
const config = {
	title: REACT_APP_COLBI_THEME && REACT_APP_COLBI_THEME !== "" ? REACT_APP_COLBI_THEME : "col.bi",
	favicon: REACT_APP_COLBI_THEME && REACT_APP_COLBI_THEME !== "" ? REACT_APP_COLBI_THEME : "logo",
}
function HeadChanger() {
	return (
		<>
			<Helmet>
				<title>{`${config.title}`}</title>
				<link
					rel="icon"
					type="image/png"
					href={`/${config.favicon}.png`}
				/>
			</Helmet>
		</>
	);
}

export default HeadChanger;
